import type { NumberFormatOptionsSignDisplay } from '@formatjs/ecma402-abstract'
import { FormattedNumber } from 'react-intl'
import { connect } from 'react-redux'

import { accountNumberFormatter, getDefaultCurrencyName, getMaximumFractionDigitsByCurrency } from '@helpers'

import { CURRENCY_OPTIONS } from '@constants'

interface AccountNumberProps {
  value?: string
}

export function AccountNumber({ value }: AccountNumberProps) {
  if (!value) {
    return null
  }
  return <span>{accountNumberFormatter.format(value)}</span>
}

export interface CurrencyProps {
  companyCurrency: string
  currencies: Currency[]
  currency?: string
  currencyId?: number
  signDisplay?: NumberFormatOptionsSignDisplay
  value: number
}

function PureCurrency({
  companyCurrency,
  currencies,
  currency = companyCurrency,
  currencyId,
  signDisplay,
  value,
}: CurrencyProps) {
  const currencyToUse = currencyId ? (currencies.find(({ id }) => id === currencyId)?.name ?? currency) : currency
  return (
    <FormattedNumber
      {...CURRENCY_OPTIONS}
      currency={currencyToUse}
      minimumFractionDigits={getMaximumFractionDigitsByCurrency(currencyToUse)}
      signDisplay={signDisplay}
      value={value}
    />
  )
}

/**
 * Component to display a value in a currency provided. If no currency is provided, it will use the default currency.
 *
 * Use with either a currency id or a currency name.
 */
export const Currency = connect((store: Store) => ({
  currencies: store.dashboard.common.currencies,
  companyCurrency: getDefaultCurrencyName(store),
}))(PureCurrency)

Currency.displayName = 'Currency'
